export abstract class BaseComponent {

  /* override this method to handle cases when component contents were reappear. Initially overriden only for grid.component.hbs */
  protected $initEmpty() { }
}